import { IApplication } from '../types';
import { IVacancies, byClassification, groupByOnboarding } from './vacancyResult';

export const CONVOCATION_FACTOR = 4;

// Espelha a regra do backend (_convocation_targets): os 4x vagas melhor classificados
// de cada série. O conjunto é sempre "os 4N melhores": quem já foi convocado continua
// nele e é só pulado no envio; o 4N+1 não sobe no lugar dele.
export const convocationTargets = (
  applications: IApplication[],
  vacancies: IVacancies,
): IApplication[] => {
  const groups = groupByOnboarding(applications);

  return Object.keys(groups).reduce((targets: IApplication[], key) => {
    const onboardingId = Number(key);
    const total = vacancies[onboardingId];

    if (total == null) return targets;

    return targets.concat(
      groups[onboardingId].slice().sort(byClassification).slice(0, CONVOCATION_FACTOR * total)
    );
  }, []);
};
